import { Menu, styled } from '@mui/material';

const StyledMenu = styled(Menu)({

});

export default StyledMenu;
